(function () {
    'use strict';

    angular.module("imApp").factory("selectStockLocationService", ['$ihttp', function ($ihttp) {
        let service = {
            getSetting: function (parms) {
                return $ihttp.post({
                    method: 942,
                    parameters: parms || {}
                });
            },
            listStockZones: function (parms) {
                return $ihttp.post({
                    method: 943,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
